import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {WinPresentationModule, WinPresentationView} from '@gongxigames/framework/slot/modules/winpresentation';
import {GlobalEventsMap} from '@gongxigames/framework/slot/events';
import {ReelsEvents} from '@gongxigames/framework/slot/modules/reels';
import {SpinButtonEvents} from '@gongxigames/framework/slot/modules/spinbutton';
import {BigWinEvents} from '@gongxigames/framework/slot/modules/bigwin';

export class WinPresentationPaysState extends ModuleState<WinPresentationView, WinPresentationModule> {

    private stopped = false;

    public onEnterState(): void {
        this.stopped = false;
        this.view.playPayAnimation();
    }

    public onLeaveState(): void {
        this.module.getEventManager<GlobalEventsMap>().emit('General.WinPresentation.PAYS_ANIMATION_STOPPED');
    }

    protected setupEvents(): void {
        this.setEventHandler(ReelsEvents.REELS_SPINNING_STARTED, this.onReelsSpinningStarted.bind(this));
        this.setEventHandler(SpinButtonEvents.SPIN_BUTTON_PRESSED, this.onReelsSpinningStarted.bind(this));
        this.setEventHandler(BigWinEvents.STARTED, this.onBigWinStarted.bind(this));
    }

    protected onReelsSpinningStarted(): void {
        if (!this.stopped) {
            this.module.stop();
            this.module.stopMeter(false);
            this.module.gotoState(WinPresentationModule.BASIC_STATE);
            this.stopped = true;
        }
    }

    protected onBigWinStarted(): void {
        this.module.stop();
    }
}
